import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6185e20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "button-group" }

import { ref } from 'vue'
import { IonButton, IonCard, IonCardContent, IonCardSubtitle, IonCardTitle, IonGrid, IonRow, IonCol, IonBadge, IonText, IonIcon, toastController } from '@ionic/vue';
import { mapOutline, refreshOutline, bookmarkOutline, bookmark, checkmarkCircleOutline } from 'ionicons/icons';
import { Store } from '@/data/classes'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreCard',
  props: ['store'],
  emits: ['toggleBookmark'],
  setup(__props, { emit }) {

const props = __props;



const store: Store = ref(props.store);

const refreshStoreQueue = async (): Promise<void> => {
    await props.store.getQueue();
    await presentToast();
}

const toggleBookmark = (): void => {
    emit("toggleBookmark", props.store.id);
}

const presentToast = async (): Promise<void> => {
    const toast = await toastController.create({
        message: '已更新店鋪籌號',
        duration: 1000,
        position: 'bottom',
        icon: checkmarkCircleOutline
    })
    await toast.present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(IonCardSubtitle), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonText), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(store.value.area), 1),
                _hoisted_1
              ]),
              _: 1
            }),
            (store.value.storeStatus == 'OPEN')
              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 0,
                  class: "badges",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("營業中")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 1,
                  class: "badges",
                  color: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("閉店中")
                  ]),
                  _: 1
                })),
            (store.value.netTicketStatus.includes('MANUAL') || store.value.netTicketStatus.includes('ONLINE'))
              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 2,
                  class: "badges",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("派籌中")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonBadge), {
                  key: 3,
                  color: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("停止派籌")
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCardTitle), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(store.value.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCardContent), { class: "no-padding mt-1" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), { class: "no-padding" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { style: {"height":"4.5rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), {
                      class: "no-padding",
                      size: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonText), null, {
                          default: _withCtx(() => [
                            _createTextVNode("輪侯組數: " + _toDisplayString(store.value.wait), 1),
                            _hoisted_2
                          ]),
                          _: 1
                        }),
                        (store.value.queue.length > 0)
                          ? (_openBlock(), _createBlock(_unref(IonText), { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("店鋪籌號: "),
                                _hoisted_3,
                                _createTextVNode(_toDisplayString(store.value.queue.join(', ')), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_unref(IonText), { key: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("暫無籌號資訊")
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), {
                      class: "no-padding flex",
                      size: "6"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(IonButton), {
                            fill: "clear",
                            size: "small",
                            href: `https://www.google.com/maps/search/?api=1&query=${store.value.address}`,
                            target: "_blank",
                            "aria-label": "在地圖搜尋此店"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "icon-only",
                                icon: _unref(mapOutline)
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["href"]),
                          _createVNode(_unref(IonButton), {
                            fill: "clear",
                            size: "small",
                            onClick: refreshStoreQueue,
                            "aria-label": "更新此店籌號"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "icon-only",
                                icon: _unref(refreshOutline)
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          (store.value.isBookmark)
                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 0,
                                fill: "clear",
                                size: "small",
                                onClick: toggleBookmark,
                                "aria-label": "標記此店；已標記的店鋪會自動更新籌號"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    icon: _unref(bookmark)
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 1,
                                fill: "clear",
                                size: "small",
                                onClick: toggleBookmark,
                                "aria-label": "取消標記此店"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    icon: _unref(bookmarkOutline)
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})